export const getPreparedRangeValue = (
  range: number[],
  realMaxValue: number,
  maxValue: number,
): [number, number] | [] => {
  if (!range || !Array.isArray(range) || range.length !== 2) {
    return [];
  }
  const [min, currentMax] = range;

  // If user selected max at or above the constant ceiling, expand to realMax
  const max = currentMax >= maxValue ? realMaxValue : currentMax;

  return [min, max];
};
